import { graphql, useStaticQuery } from "gatsby"

export const useStaticJobRoles = () => {
  const data = useStaticQuery(graphql`
    query {
      allJobRole(filter: { title: { ne: "" } }) {
        nodes {
          title
          location
          link
          isUKRemote
          isHybrid
        }
      }
    }
  `)
  return data.allJobRole.nodes
}
